import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { appService } from '../../../_services/app.service';
import { DecryptPipe } from '../../../auth/_services/encrypt-decrypt.pipe';

@Component({
  selector: 'app-new-trip-milestones',
  templateUrl: './new-trip-milestones.component.html',
  styleUrls: ['./new-trip-milestones.component.scss']
})
export class NewTripMilestonesComponent implements OnInit, OnDestroy {

  static that: NewTripMilestonesComponent;
  @Input() BookingId: any;
  @Input() Mode: any;
  @Output() onCloseEvent = new EventEmitter<any>();
  @Output() onRefreshCall = new EventEmitter<any>();
  CompanyId: any;
  userId: any;
  mileStoneArray: any = []
  originalMilestoneArray: any = []
  isAttachmentShow: boolean = false;
  attachmentStage: any;

  ActualDate = {
    // lable: 'Order Date',
    formControlName: 'ActualDate',
    dataField: 'ActualDate',
    placeholder: 'Select Date',
    isTime: true,
  };
  Odometer = {
    // lable: 'Order Date',
    formControlName: 'Odometer',
    dataField: 'Odometer',
    placeholder: 'Enter odometer',
  };
  Remark = {
    // lable: 'Order Date',
    formControlName: 'Remark',
    dataField: 'Remark',
    placeholder: 'Enter remark',
  };
  EstimateDate = {
    // lable: 'Order Date',
    formControlName: 'EstimateDate',
    dataField: 'EstimateDate',
    placeholder: 'Select Date',
    isReadOnly: true,
    isTime: true,
  };
  private hasValidationError: boolean = false; // added by yash 10-08-2026
  @Input() ConsignmentDetailId: any;

  constructor(
    private router: Router,
    private _appService: appService,
    private toastr: ToastrService,
    private decryptpipe: DecryptPipe,
    private cookieService: CookieService,
    private renderer: Renderer2
  ) {
    NewTripMilestonesComponent.that = this;
  }

  ngOnInit() {
    const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
    this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    if (this.BookingId) {
      this.getMileStoneList(this.BookingId, this.Mode);
    }

    this.renderer.addClass(document.body, 'modal-lg-override-milestone');
  }

  ngOnDestroy(): void {
    this.renderer.removeClass(document.body, 'modal-lg-override-milestone');
  }

  getMileStoneList(Id, Type) {
    this._appService.GetByTwoParam("OrdersByVehicle", "getMileStoneList", Id, Type).subscribe(
      (response) => {
        this.mileStoneArray = response;
        this.originalMilestoneArray = JSON.parse(JSON.stringify(this.mileStoneArray));
        console.log("Response From milestone:", response);

      },
      (error) => {
        console.error("Error while getting milestone list");
      }
    );
  }

  close() {
    this.onCloseEvent.emit();
  }

  // added by yash 10-08-2026
  private validateMilestoneSequence(): { isValid: boolean; message: string } {
    const datedMilestones = this.mileStoneArray
      .filter(m => m.ActualDate)
      .map((m, index) => ({
        ...m,
        originalIndex: index,
        date: new Date(m.ActualDate)
      }))
      .sort((a, b) => a.date.getTime() - b.date.getTime());

    for (let i = 0; i < datedMilestones.length - 1; i++) {
      const current = datedMilestones[i];
      const next = datedMilestones[i + 1];

      if (current.originalIndex > next.originalIndex) {
        return {
          isValid: false,
          message: this.generateWarningMessage(current, next)
        };
      }
    }
    return { isValid: true, message: '' };
  }

  private generateWarningMessage(current: any, next: any): string {  // added by yash 11-08-2026
    const earlierMilestone = next.stageName;
    const laterMilestone = current.stageName;

    return `"${earlierMilestone}" date should be before "${laterMilestone}" date. Please correct the sequence.`;
  }

  private formatDate(date: Date): string {
    if (!date) return '';
    return date.toLocaleString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }
  // end by yash 10-08-2026

  getChangedValue(value, data, index, stagename) {
    if (value) {
      // if (stagename === 'Origin Pending Gate Out') {  // commented by yash 10-08-2026
      //   const OriginPendingGateIn = this.mileStoneArray.find(ele => ele.stageName === 'Origin Pending Gate In');

      //   if (OriginPendingGateIn && OriginPendingGateIn.ActualDate) {
      //     const originPendingGateInDate = new Date(OriginPendingGateIn.ActualDate);
      //     const newValueDate = new Date(value);

      //     // Compare dates
      //     if (newValueDate <= originPendingGateInDate) {
      //       this.toastr.warning("Please select a date greater than 'Origin Pending Gate In'");
      //       return;
      //     }
      //   }
      // }
      // added by yash 10-08-2026
      // const previousValue = this.mileStoneArray[index][data.dataField];  // commented by yash 

      this.mileStoneArray[index][data.dataField] = value;

      // const validation = this.validateMilestoneSequence();    // commented by yash 
      // if (!validation.isValid) {
      //   this.mileStoneArray[index][data.dataField] = previousValue;
      //   this.toastr.warning(validation.message);
      //   this.hasValidationError = true;
      //   return;
      // }
      // this.hasValidationError = false;
      // end by yash 10-08-2026
    } else {
      this.mileStoneArray[index][data.dataField] = '';
      // added by yash 10-08-2026
      // const validation = this.validateMilestoneSequence();  // commented by yash 
      // this.hasValidationError = !validation.isValid;
      // end by yash 10-08-2026
    }
    console.log(this.mileStoneArray);
  }

  onSaveBtnClick() {
    // added by yash 10-08-2026
    const validation = this.validateMilestoneSequence();
    if (!validation.isValid) {
      this.toastr.warning(validation.message);
      return;
    }
    // if (this.hasValidationError) {  // commented by yash
    //   this.toastr.error("Please fix the milestone date sequence errors before saving.")
    //   return;
    // }
    // end by yash 10-08-2026
    let obj: any = {};
    obj.CreatedBy = this.userId;

    let changedData: any[] = [];

    // for (let i = 0; i < this.mileStoneArray.length; i++) {
    //   const current = this.mileStoneArray[i];

    //   if (current.IsMandatory && !current.ActualDate) {
    //     this.toastr.warning(`"${current.stageName}" is mandatory. Please enter Actual Date.`);
    //     return; 
    //   }
    // }

    for (let i = 0; i < this.mileStoneArray.length; i++) {
      const current = this.mileStoneArray[i];
      const original = this.originalMilestoneArray[i];

      // Check for new data entered (Id is null, but any value entered)
      const isNewEntry =
        !current.Id &&
        (current.ActualDate || current.Odometer || current.Remark);

      // Check for modifications (Id exists and any value changed)
      const isModifiedEntry =
        current.Id &&
        (
          (!original || current.ActualDate !== original.ActualDate) ||
          (!original || current.Odometer !== original.Odometer) ||
          (!original || current.Remark !== original.Remark)
        );

      if (isNewEntry || isModifiedEntry) {
        // changedData.push(current);
        let entryToPush = { ...current };

        //  Add BookingId only for new entries
        if (isNewEntry) {
          entryToPush.BookingId = this.BookingId;
        }

        changedData.push(entryToPush);
      }
    }

    // added by yash 10-08-2026
    if (changedData.length === 0) {
      this.toastr.info("No changes to save");
      return;
    }
    // end by yash 10-08-2026

    obj.TrackingMilestonebyTrip_Table = changedData;
    console.log(obj);

    this._appService.Post("OrdersByVehicle", "save_TrackingMilestonebyTrip", obj).subscribe(
      (response) => {
        if (response) {
          this.toastr.success("Data saved successfully!");
          this.onRefreshCall.emit('true');
          this.close();
        }
      },
      (error) => {

      }
    );
  }

  openAttachment(stage) {
    if(stage == 'Pending To Close'){
      stage = 'POD';
    }
    this.attachmentStage = stage;
    this.isAttachmentShow = true;
  }

  closeattach() {
    this.isAttachmentShow = false;
  }


}

